import React, { useState, useEffect } from 'react';
import __, { __route } from 'localisation';
import Heading from 'components/Heading';
import Main from 'components/Main';
import SourceProgress from 'components/SourceProgress';
import SourceCards from 'components/SourceCards';
import { Columns, Column } from 'components/Columns';
import { LoadingBox } from 'components/LoadingIndicators';
import Button, { ButtonWrap } from '@hubins/components/Button';
import ErrorMessage from 'components/ErrorMessage';
import { Redirect } from 'react-router-dom';
import Modal from 'components/Modal';
import { getMoney } from 'helpers';

import middleman from 'helpers/middleman';


const add = (current, value) => {
  current += value;
  return current;
};

const Source = ({ transaction, portfolioUuid }) => {
  const [sourceAmounts, setSourceAmounts] = useState(false);
  const [sources, setSources] = useState(false);
  const [error, setError] = useState(false);
  const [redirect, setRedirect] = useState(false);

  const [unprovenSources, setUnprovenSources] = useState(false);
  const [lockedSources, setLockedSources] = useState(false);
  const [loading, setLoading] = useState(false);

  const init = async () => {
    const response = await middleman.promiseGet(`/source-of-funds/show/${transaction.portfolio_uuid}`);
    const amounts = response.data.map(() => 0);
    setSourceAmounts(amounts);
    setSources(response.data);
  };

  useEffect(() => {
    if (transaction) {
      init();
    }
  }, [transaction]);

  const submit = async () => {
    try {
      setLoading(true);
      const usedSources = sources.map((source, index) => {
        return {
          'id': source.uuid,
          'amount': sourceAmounts[index]
        };
      }).filter(source => {
        return source.amount > 0;
      });

      const usedAmount = usedSources.reduce((sum, item) => {
        sum += Number(item.amount);
        return sum;
      }, 0);

      if (usedAmount !== transaction.amount / 100) {
        setLoading(false);
        setError(__('insufficient_transaction_amount'));
        return;
      }

      // TODO: handle response? Show if source needs proof etc
      const response =  await middleman.promisePost(`/transactions/update/${portfolioUuid}`, {
        id: transaction.uuid,
        pid: transaction.portfolio_uuid,
        sources: usedSources
      }).then(res => res.data);

      const resSources = response.source_of_funds;

      const sourcesWithLockedStatus = resSources.filter((item) => {
        return item.status === 'locked';
      });

      const proofNeededFor = resSources.filter((item) => {
        return item.status === 'proof_needed';
      });

      if (proofNeededFor.length > 0) {
        setUnprovenSources(proofNeededFor);
        return;
      }

      if (sourcesWithLockedStatus.length > 0) {
        setLockedSources(sourcesWithLockedStatus);
        return;
      }

      if (response.status === 'completed') {
        setRedirect(`${__route("depositInstructions")}/s/${response.uuid}`);
        return;
      }

      setRedirect(__route('root'));
    } catch(e) {
      setError(__('common_error_validation'));
      setLoading(false);
    }
  };

  if (redirect) return <Redirect to={redirect} />;

  if (lockedSources || unprovenSources) {
    return (
      <Modal
        open={true}
      >
        <Heading size="3">
          Din transaktion behöver granskas
        </Heading>
        <p>Vi kommer granska din transaktion. När detta är klart kan transaktionen slutföras</p>
        {unprovenSources && (
          <>
            <Heading size="5">Du kommer även behöva skicka in bevis för följande källor innan vi kan slutföra granskningen:</Heading>
            <ul>
              {unprovenSources.map((item, index) => (
                <li key={`${index}-unprovensource`}>
                  {__(`sof_${item.type}`)}: {getMoney(item.declared_amount)}
                </li>
              ))}
            </ul>
            <p className='s-md'>Gå till Hantera källor för att skicka in bevis</p>
          </>
        )}
        <ButtonWrap>
          {unprovenSources && (
            <Button
              className="cta"
              href={`/#${__route('mySources')}`}
            >
              Hantera källor
            </Button>
          )}
          <Button
            className="secondary"
            href={__route('root')}
          >
            Startsida
          </Button>
        </ButtonWrap>
      </Modal>
    );
  }

  if (sources === false) return <LoadingBox />;

  const totalSelectedSum = sourceAmounts.reduce(add, 0);

  return (
    <Main>
      <Columns>
        <Column s="12">
          <Heading size="3">
            Premieinsättning
          </Heading>
          <Heading size="4">
            Insättningar av deklarerat belopp
          </Heading>
          <p>Lorem, ipsum dolor sit amet consectetur adipisicing elit. Commodi impedit doloribus adipisci eveniet blanditiis fugiat quibusdam ea temporibus reiciendis, expedita voluptatibus molestiae id hic quia quas voluptate accusantium vel velit.</p>
        </Column>
        <Column s="12">
          <SourceProgress
            totalSelectedSum={totalSelectedSum}
            totalAmount={transaction.amount / 100}
            sourceAmounts={sourceAmounts}
            sources={sources}
          />
        </Column>
        <Column s="12">
          <Heading size="4">Välj källa för insättning</Heading>
        </Column>
        <SourceCards
          totalAmount={transaction.amount / 100}
          sourceAmounts={sourceAmounts}
          sources={sources}
          setSources={setSources}
          setSourceAmounts={setSourceAmounts}
          premium={true}
          portfolioUuid={transaction.portfolio_uuid}
          totalSelectedSum={totalSelectedSum}
        />
        <Column s="12" className="center padding s-top-l">
          <Button
            className="cta spacing"
            onClick={submit}
            loading={loading}
            disabled={loading}
          >
            Genomför insättning
          </Button>
          <ErrorMessage
            text={error}
            showError={error}
          />
        </Column>
      </Columns>
    </Main>
  );
};

export default Source;
